console.log("init Proteus treatments -- 1.02");

// attentive popup event tracking -- v1.1
window.addEventListener("message", function (e) {
  
  const a = e?.data?.__attentive;

  if (!a || !a.creativeId || !a.action) return;
  console.log("ATTENTIVE MESSAGE:", e.data);
  window.dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: "proteus_custom_event",
    proteus_event_name: `ATTN ${a.creativeId} -- ${a.action}`,
    proteus_event_category: "CRO",
    page_location: location.href
  });
});

// alia event tracking
const aliaEvents = [
  "alia:popupView",
  "alia:signup",
  "alia:popupClose",
  "alia:campaignMatched",
  "alia:pollAnswered",
  "alia:rewardClaimed",
];

aliaEvents.forEach(function (evtName) {
  document.addEventListener(evtName, function (e) {
    console.log("ALIA EVENT:", evtName, e.detail, `ALIA -- ${e.detail.popupID} ${e.detail.type}`);

    window.dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: "proteus_custom_event",
      proteus_event_name: `ALIA -- ${e.detail.popupID} ${e.detail.type}`,
      proteus_event_category: "CRO",
      page_location: window.location.href,
      alia_data: e.detail || {}
    });
  });
});

// ─── B-06: Evergreen Homepage ───────────────────────────────────
(function () {

  // ─── SETTINGS ─────────────────────────────────────────────────────────────
  const SETTINGS = {
    videoSrc:        '//www.bombshellsportswear.com/cdn/shop/videos/c/vp/c842560bdb0c446b9c0880fc521ba62f/c842560bdb0c446b9c0880fc521ba62f.HD-1080p-4.8Mbps-50119040.mp4?v=0',
    videoPoster:     '//www.bombshellsportswear.com/cdn/shop/files/preview_images/c842560bdb0c446b9c0880fc521ba62f.thumbnail.0000000000_800x.jpg?v=1750972461',
    videoAlt:        'Video of a fit model wearing a black keyhole detailed sports bra and matching biker shorts.',
    heading:         'Elevate your workout',
    body:            "Find motivation and confidence with Bombshell Sportswear's fashionable &amp; functional women's gym clothes &amp; workout outfits.",
    buttons: [
      { label: 'BEST SELLERS', href: '/collections/best-sellers' },
      { label: 'NEW ARRIVALS', href: '/collections/new' },
    ],
    overlayOpacity:  0.15,
    overlayColor:    '0 0 0',
    textColor:       '255 255 255',
  };

  // ─── CSS ──────────────────────────────────────────────────────────────────
  const CSS = `
    #b06-hero {
      --content-over-media-overlay: ${SETTINGS.overlayColor} / ${SETTINGS.overlayOpacity};
      --text-color: ${SETTINGS.textColor};
      --section-outer-spacing-block: 0;
      margin-block-start: calc(-1 * var(--header-height) * var(--section-is-first));
    }

    #b06-hero .b06-media {
      position: relative;
      display: grid;
    }

    #b06-hero .b06-media::after {
      content: '';
      position: absolute;
      inset: 0;
      background: rgb(${SETTINGS.overlayColor}) / ${SETTINGS.overlayOpacity};
      background: rgba(${SETTINGS.overlayColor.split(' ').join(',')}, ${SETTINGS.overlayOpacity});
      pointer-events: none;
      z-index: 1;
    }

    #b06-hero video-media {
      display: block;
      width: 100%;
    }

    #b06-hero video-media video {
      width: 100%;
      display: block;
      object-fit: cover;
      height: 72vh;
      min-height: 500px;
    }

    #b06-hero .b06-content {
      position: absolute;
      inset: 0;
      display: grid;
      place-items: center;
      text-align: center;
      z-index: 2;
      color: rgb(${SETTINGS.textColor});
      padding: 1rem;
    }

    #b06-hero .b06-prose {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 780px;
    }

    #b06-hero .b06-heading {
      font-weight: 700 !important;
      text-transform: uppercase;
      font-size: 1.5rem;
      letter-spacing: 0.08em;
      color: inherit;
      overflow-wrap: anywhere;
    }

    @media screen and (min-width: 700px) {
      #b06-hero .b06-heading {
        font-size: 1.75rem;
      }
    }

    #b06-hero .b06-body {
      margin-block-start: 1.25rem;
      margin-bottom: 0;
      color: inherit;
      font-weight: 500;
    }

    @media screen and (min-width: 700px) {
      #b06-hero .b06-body {
        margin-block-start: 1.5rem;
      }
    }

    #b06-hero .b06-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;
      justify-content: center;
      margin-block-start: 1.5rem;
    }

    @media screen and (min-width: 700px) {
      #b06-hero .b06-buttons {
        margin-block-start: 2rem;
      }
    }

    #b06-hero .b06-btn {
      display: inline-block;
      background: none;
      box-shadow: inset 0 0 0 2px rgb(${SETTINGS.textColor});
      color: rgb(${SETTINGS.textColor});
      text-decoration: none;
      font-size: 0.875rem;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      padding: 0.8125rem 1rem;
      transition: background 0.15s ease-in-out, color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      border: none;
      min-width: 150px;
    }

    @media screen and (min-width: 700px) {
      #b06-hero .b06-btn {
        padding: 0.8125rem 2rem;
      }
    }

    #b06-hero .b06-btn:hover {
      background: rgb(${SETTINGS.textColor});
      color: rgb(0, 0, 0);
      box-shadow: inset 0 0 0 2px rgb(${SETTINGS.textColor});
    }
  `;

  // ─── BUILD HTML ───────────────────────────────────────────────────────────
  function buildHero() {
    const buttons = SETTINGS.buttons.map(btn =>
      `<a class="b06-btn button button--lg button--outline" href="${btn.href}">${btn.label}</a>`
    ).join('');

    return `
      <section id="b06-hero" class="shopify-section">
        <div class="b06-media content-over-media content-over-media--lg full-bleed">
          <video-media autoplay>
            <video
              playsinline
              muted
              loop
              preload="metadata"
              aria-label="${SETTINGS.videoAlt}"
              poster="${SETTINGS.videoPoster}"
            >
              <source src="${SETTINGS.videoSrc}" type="video/mp4">
              <img src="${SETTINGS.videoPoster}" alt="${SETTINGS.videoAlt}">
            </video>
          </video-media>
          <div class="b06-content">
            <div class="b06-prose prose">
              <h2 class="b06-heading">${SETTINGS.heading}</h2>
              <p class="b06-body">${SETTINGS.body}</p>
              <div class="b06-buttons">${buttons}</div>
            </div>
          </div>
        </div>
      </section>
      
    `;
  }

  // ─── PUBLIC API ───────────────────────────────────────────────────────────
  window.activateB06 = function () {
    if (window._b06Active) return;
    window._b06Active = true;

    if (window.location.pathname !== '/') return;

    if (!document.getElementById('b06-styles')) {
      const style = document.createElement('style');
      style.id = 'b06-styles';
      style.textContent = CSS;
      document.head.appendChild(style);
    }

    waitForElement('slideshow-component').then(slideshowEl => {

      const targetSection = slideshowEl.closest('.shopify-section');
      if (!targetSection) return;

      const heroEl = document.createElement('div');
      heroEl.innerHTML = buildHero();
      const heroSection = heroEl.firstElementChild;

      targetSection.replaceWith(heroSection);

      const video = heroSection.querySelector('video');
      if (video) {
        video.muted = true;
        video.play().catch(() => {});
      }

      console.log('[B06] Treatment active');

    }).catch();
  };

})();
// End B06


// ─── B-04: Navigation Hierarchy ───────────────────────────────────
// Desktop (>1024px): replaces nav#main-navigation
// Mobile (≤1024px): replaces #menu-drawer content
(function () {
  // ─── DESKTOP: Promo image data ────────────────────────────────────────────
  const PROMO = {
    trending: [
      {
        href: '/collections/matching-sets',
        src: '//www.bombshellsportswear.com/cdn/shop/files/2O6A8184-Edit.png?v=1777024151',
        label: 'MATCHING SETS',
      },
      {
        href: '/collections/new',
        src: 'https://cdn.shopify.com/s/files/1/0580/1077/files/NewArrivals_MobileBanner_1100x660_1100x_f9259adb-27ef-4087-a2f7-43ac55576dd0.jpg?v=1780857581',
        label: 'NEW ARRIVALS',
      },
    ],
    shop: [
      {
        href: '/collections/all-tops',
        src: '//www.bombshellsportswear.com/cdn/shop/files/NEWARRIVALS_1368x1859_2_1.png?v=1777023907',
        label: 'ALL TOPS',
      },
      {
        href: '/collections/all-bottoms',
        src: '//www.bombshellsportswear.com/cdn/shop/files/NEWARRIVALS_1368x1859_3_43ccac68-1ab6-474c-a348-810d2cdaa561.png?v=1777023926',
        label: 'ALL BOTTOMS',
      },
    ],
  };

  // ─── DESKTOP: Menu data ───────────────────────────────────────────────────
  const NAV = [
    {
      label: 'New Arrivals',
      href: '/collections/new',
      dropdown: null,
    },
    {
      label: 'Trending',
      href: null,
      dropdown: {
        promoKey: 'trending',
        columns: [
          {
            heading: 'Shop All',
            headingHref: '/collections/shop-all',
            links: [
              { label: 'Best Sellers', href: '/collections/best-sellers' },
              { label: 'New Arrivals', href: '/collections/new' },
              { label: 'Just Restocked', href: '/collections/just-restocked-1' },
              { label: 'Matching Sets', href: '/collections/matching-sets' },
              { label: 'Loungewear', href: '/collections/lounge-1' },
              { label: 'Swimwear', href: '/collections/bomshell-swim-collection' },
              { label: 'Gift Card', href: '/products/bombshell-babe-gift-card-1' },
              { label: 'Sale', href: '/collections/sale' },
            ],
          },
        ],
      },
    },
    {
      label: 'Shop',
      href: null,
      dropdown: {
        promoKey: 'shop',
        columns: [
          {
            heading: 'Bottoms',
            headingHref: '/collections/all-bottoms',
            links: [
              { label: 'Leggings', href: '/collections/leggings' },
              { label: 'Shorts', href: '/collections/shorts' },
              { label: 'Skirts', href: '/collections/skirts' },
              { label: 'Joggers', href: '/collections/joggers' },
            ],
          },
          {
            heading: 'Tops',
            headingHref: '/collections/all-tops',
            links: [
              { label: 'Sports Bras', href: '/collections/sports-bras' },
              { label: 'Tanks', href: '/collections/tanks' },
              { label: 'Tees', href: '/collections/tees' },
              { label: 'Long Sleeves', href: '/collections/long-sleeves' },
            ],
          },
          {
            heading: 'One Pieces',
            headingHref: '/collections/one-pieces',
            links: [
              { label: 'Bodysuits', href: '/collections/bodysuits-1' },
              { label: 'Dresses', href: '/collections/dresses' },
              { label: 'Jumpsuits', href: '/collections/jumpsuits' },
            ],
          },
          {
            heading: 'Accessories',
            headingHref: '/collections/accessories',
            links: [
              { label: 'Socks', href: '/collections/socks' },
              { label: 'Hats', href: '/collections/hats' },
              { label: 'Scrunchies', href: '/collections/scrunchies' },
              { label: 'Underwear', href: '/collections/gymkini-underwear' },
            ],
          },
        ],
      },
    },
    {
      label: 'More',
      href: null,
      dropdown: {
        promoKey: 'more',
        columns: [
          {
            heading: 'Rewards',
            headingHref: null,
            links: [
              { label: 'Exclusive Discounts', href: '/pages/exclusive-discounts' },
              { label: 'Rewards Program', href: '/pages/bombshell-rewards' },
            ],
          },
          {
            heading: 'Community',
            headingHref: null,
            links: [
              { label: 'Bombshell Blog', href: '/blogs/sexy-blog' },
              { label: 'Customer Reviews', href: '/pages/reviews' },
              { label: 'Download the App', href: '/pages/download-the-app' },
            ],
          },
          {
            heading: 'Returns & Exchanges',
            headingHref: '/pages/returns-exchanges',
            links: [
              { label: 'Shipping Info', href: '/pages/shipping-information' },
              { label: 'Order Tracking', href: 'https://www.bombshellsportswear.com/pages/order-tracking' },
              { label: 'Size Chart', href: '/pages/size-chart' },
            ],
          },
          {
            heading: 'Help',
            headingHref: null,
            links: [
              { label: 'Our Fabrics', href: '/pages/our-fabrics' },
              { label: 'Product Care', href: '/pages/garment-care' },
              { label: 'FAQ', href: '/pages/faqs' },
              { label: 'Contact', href: '/pages/contact' },
            ],
          },
        ],
      },
    },
  ];

  // ─── MOBILE: Nav data ─────────────────────────────────────────────────────
  const MOBILE_NAV = [
    { label: 'Shop All',     href: '/collections/shop-all',    sub: null },
    { label: 'New Arrivals', href: '/collections/new',          sub: null },
    { label: 'Best Sellers', href: '/collections/best-sellers', sub: null },
    {
      label: 'Tops', href: null,
      sub: [
        { label: 'Sports Bras', href: '/collections/sports-bras' },
        { label: 'Tanks', href: '/collections/tanks' },
        { label: 'Tees', href: '/collections/tees' },
        { label: 'Long Sleeves', href: '/collections/long-sleeves' },
        { label: 'All Tops', href: '/collections/all-tops' },
      ],
    },
    {
      label: 'Bottoms', href: null,
      sub: [
        { label: 'Leggings', href: '/collections/leggings' },
        { label: 'Shorts', href: '/collections/shorts' },
        { label: 'Skirts', href: '/collections/skirts' },
        { label: 'Joggers', href: '/collections/joggers' },
        { label: 'All Bottoms', href: '/collections/all-bottoms' },
      ],
    },
    {
      label: 'One Pieces', href: null,
      sub: [
        { label: 'Bodysuits', href: '/collections/bodysuits-1' },
        { label: 'Dresses',   href: '/collections/dresses' },
        { label: 'Jumpsuits', href: '/collections/jumpsuits' },
        { label: 'All One Pieces', href: '/collections/one-pieces' },
      ],
    },
    { label: 'Accessories', href: '/collections/accessories', sub: null },
    {
      label: 'More', href: null,
      sub: [
        { label: 'Exclusive Discounts', href: '/pages/exclusive-discounts' },
        { label: 'Rewards Program',     href: '/pages/bombshell-rewards' },
        { label: 'Bombshell Blog',      href: '/blogs/sexy-blog' },
        { label: 'Customer Reviews',    href: '/pages/reviews' },
        { label: 'Download the App',    href: '/pages/download-the-app' },
        { label: 'Shipping Info',       href: '/pages/shipping-information' },
        { label: 'Order Tracking',      href: '/pages/order-tracking' },
        { label: 'Size Chart',          href: '/pages/size-chart' },
        { label: 'Our Fabrics',         href: '/pages/our-fabrics' },
        { label: 'Product Care',        href: '/pages/garment-care' },
        { label: 'FAQ',                 href: '/pages/faqs' },
        { label: 'Contact',             href: '/pages/contact' },
      ],
    },
    { label: 'Sale', href: '/collections/sale', sub: null },
  ];

  const MOBILE_PROMOS = [
    {
      href:  '/collections/matching-sets',
      src:   '//www.bombshellsportswear.com/cdn/shop/files/2O6A8184-Edit.png?v=1777024151',
      label: 'MATCHING SETS',
    },
    {
      href:  '/collections/new',
      src:   'https://cdn.shopify.com/s/files/1/0580/1077/files/NewArrivals_MobileBanner_1100x660_1100x_f9259adb-27ef-4087-a2f7-43ac55576dd0.jpg?v=1780857581',
      label: 'NEW ARRIVALS',
    },
  ];

  // ─── DESKTOP CSS ──────────────────────────────────────────────────────────
  const CSS = `
    @media screen and (max-width: 1024px) {
      #b04-main-nav {
        display: none !important;
      }
    }

    #b04-main-nav {
      display: flex;
      align-items: stretch;
      animation: b04FadeIn 0.3s ease forwards;
    }

    @keyframes b04FadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }

    .b04-nav {
      display: flex;
      align-items: center;
      gap: 32px;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .b04-nav__item {
      position: static;
      display: flex;
      align-items: stretch;
      padding: 34px 0px;
    }

    /* ── triggers ── */
    .b04-nav__trigger {
      display: flex;
      align-items: center;
      gap: 5px;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      font-family: inherit;
      font-size: 13px;
      font-weight: 600 !important;
      color: inherit;
      text-decoration: none;
      text-transform: uppercase;
      white-space: nowrap;
      transition: opacity 0.2s ease-in-out;
    }

    .b04-nav__trigger:hover {
      opacity: 0.7;
    }

    .b04-nav__trigger svg {
      width: 10px;
      height: 7px;
      flex-shrink: 0;
      transition: transform 0.2s ease-in-out;
    }

    .b04-nav__item.is-open > .b04-nav__trigger svg {
      transform: rotate(180deg);
    }

    /* ── dropdown panel ── */
    .b04-dropdown {
      display: none;
      position: fixed;
      left: 0;
      right: 0;
      top: var(--b04-header-height, 80px);
      background: #fff;
      color: inherit;
      border-top: 1px solid rgba(0,0,0,0.12);
      box-shadow: 0 9999px 0 9999px rgba(0,0,0,0.35);
      z-index: 200;
      padding: 3rem 4rem;
      align-items: flex-start;
      gap: 2rem;
    }

    .b04-nav__item.is-open > .b04-dropdown {
      display: flex;
    }

    /* ── column nav area ── */
    .b04-dropdown__columns {
      display: flex;
      gap: 4rem;
      flex: auto;
      align-items: flex-start;
      flex-wrap: wrap;
    }

    .b04-dropdown__col {
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 140px;
    }

    .b04-dropdown__col-heading {
      font-weight: 600;
      font-style: normal;
      font-size: 13px;
      text-transform: uppercase;
      line-height: 1.4;
      color: inherit;
      text-decoration: none;
      display: block;
      background: linear-gradient(to right, currentColor, currentColor) 0 min(100%, 1.35em) / 0 1px no-repeat;
      transition: background-size 0.3s ease-in-out;
    }

    .b04-dropdown__col-heading:hover {
      background-size: 100% 1px;
    }

    .b04-dropdown__col-heading--plain {
      background: none;
      cursor: default;
    }

    .b04-dropdown__links {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .b04-dropdown__link {
      font-size: 13px;
      color: inherit;
      opacity: 0.7;
      text-decoration: none;
      line-height: 1.6;
      transition: opacity 0.2s ease-in-out;
      display: block;
    }

    .b04-dropdown__link:hover {
      opacity: 1;
    }

    /* ── promo images area ── */
    .b04-dropdown__promos {
      display: flex;
      gap: 12px;
      flex-shrink: 0;
    }

    .b04-dropdown__promo {
      position: relative;
      width: clamp(200px, 18vw, 300px);
      border-radius: 4px;
      display: block;
      text-decoration: none;
      flex-shrink: 0;
      overflow: hidden;
    }

    .b04-dropdown__promo::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40%;
      background: linear-gradient(to top, rgba(0,0,0,0.4), transparent);
      pointer-events: none;
    }

    .b04-dropdown__promo img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      display: block;
      transition: transform 0.3s ease-in-out;
    }

    .b04-dropdown__promo:hover img {
      transform: scale(1.04);
    }

    .b04-dropdown__promo--square {
      aspect-ratio: 1;
    }

    .b04-dropdown__promo:not(.b04-dropdown__promo--square) img {
      height: auto;
    }

    .b04-dropdown__promo-label {
      position: absolute;
      bottom: 12px;
      left: 12px;
      color: #fff;
      font-weight: 500;
      font-size: 1rem;
      text-transform: uppercase;
      z-index: 1;
    }

    @media screen and (max-width: 1468px) {
      .b04-dropdown {
        padding: 4rem 2rem;
      }
      .b04-dropdown, .b04-dropdown__columns {
        gap: 1rem;
      }
    }
    @media screen and (max-width: 1117px) {
      .b04-dropdown {
        padding: 4rem 1rem;
      }
      .b04-dropdown__promo {
        width: 171px;
      }
    }
  `;

  // ─── MOBILE CSS ───────────────────────────────────────────────────────────
  const MOBILE_CSS = `
    #b04-mobile-drawer {
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #fff;
      color: #000;
      font-family: inherit;
      overflow: hidden;
      position: relative;
    }

    .b04m-header {
      display: flex;
      justify-content: flex-end;
      padding: 0 28px;
      flex-shrink: 0;
    }

    .b04m-panels {
      display: flex;
      flex: 1;
      overflow: hidden;
      position: relative;
      text-align: left;
    }

    .b04m-panel {
      flex-shrink: 0;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overscroll-behavior-y: contain;
      transition: transform 0.3s ease, opacity 0.2s ease, visibility 0.2s ease;
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 15px 30px;
      box-sizing: border-box;
    }

    .b04m-panel--root {
      transform: translateX(0);
      opacity: 1;
      visibility: visible;
    }

    .b04m-panel--sub {
      transform: translateX(100%);
    }

    .b04m-panel--sub.is-active {
      opacity: 1;
      visibility: visible;
      transform: translateX(0%);
    }

    .b04m-panel--root.is-behind {
      transform: translateX(-100%);
      opacity: 0;
      visibility: hidden;
    }

    .b04m-close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid rgba(0,0,0,0.15);
      background: none;
      cursor: pointer;
      margin-left: auto;
      flex-shrink: 0;
    }

    .b04m-close svg {
      width: 14px;
      height: 14px;
    }

    /* ── back button ── */
    .b04m-back {
      display: flex;
      align-items: center;
      gap: 6px;
      background: none;
      border: none;
      cursor: pointer;
      font-size: 1rem;
      text-transform: uppercase;
      color: rgba(0,0,0,0.5);
      padding: 0;
      margin-bottom: 1rem;
      font-weight: 600 !important;
    }

    .b04m-back svg {
      width: 14px;
      height: 14px;
    }

    /* ── nav list ── */
    .b04m-list {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      margin-top: 10px;
    }

    .b04m-listItem:not(:last-child),
    .b04m-sub-link:not(:last-child) {
      border-bottom: 1px solid #f0f0f0;
    }

    .b04m-link,
    .b04m-expandable,
    .b04m-sub-link {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 1rem 0;
      font-size: .9rem;
      font-weight: 600 !important;
      line-height: 24px;
      color: #000;
      text-decoration: none;
      background: none;
      border: none;
      cursor: pointer;
      text-align: left;
    }
    
    .b04m-chevron {
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 50%;
      background: #ececec;
      flex-shrink: 0;
      display: grid;
      place-items: center;
      transition: all 0.2s ease-in-out;
    }

    .b04m-chevron svg {
      width: 12px;
      height: 12px;
    }

    .b04m-link:hover, .b04m-sub-link:hover {
      color: inherit;
    }

    /* ── promo tiles ── */
    .b04m-promos {
      display: flex;
      gap: 10px;
      margin-top: 10px;
    }

    .b04m-promo {
      flex: 1;
      position: relative;
      aspect-ratio: 1;
      overflow: hidden;
      border-radius: 4px;
      display: block;
      text-decoration: none;
    }

    .b04m-promo::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40%;
      background: linear-gradient(to top, rgba(0,0,0,0.4), transparent);
      pointer-events: none;
    }

    .b04m-promo img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .b04m-promo-label {
      position: absolute;
      bottom: 10px;
      left: 10px;
      color: #fff;
      font-weight: 500;
      font-size: 1rem;
      text-transform: uppercase;
      z-index: 1;
    }

    /* ── More promo — natural ratio, full width ── */
    .b04m-more-promo {
      display: block;
      margin-top: 24px;
      border-radius: 4px;
      overflow: hidden;
      text-decoration: none;
    }

    .b04m-more-promo img {
      width: 100%;
      height: auto;
      display: block;
    }
  `;

  // ─── DESKTOP helpers ──────────────────────────────────────────────────────
  function chevronSVG() {
    return `<svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="m1 1 4 4 4-4" stroke="currentColor" stroke-width="2"/></svg>`;
  }

  function buildPromos(promoKey) {
    const items = PROMO[promoKey];
    if (!items || !items.length) return '';
    const isSquare = promoKey !== 'more';
    const imgs = items.map(p => `
      <a href="${p.href}" class="b04-dropdown__promo${isSquare ? ' b04-dropdown__promo--square' : ''}">
        <img src="${p.src}" alt="${p.label}" loading="lazy">
        ${p.label ? `<span class="b04-dropdown__promo-label">${p.label}</span>` : ''}
      </a>
    `).join('');
    return `<div class="b04-dropdown__promos">${imgs}</div>`;
  }

  function buildDropdown(dropdown) {
    const cols = dropdown.columns.map(col => {
      const headingEl = col.headingHref
        ? `<a href="${col.headingHref}" class="b04-dropdown__col-heading">${col.heading}</a>`
        : `<span class="b04-dropdown__col-heading b04-dropdown__col-heading--plain">${col.heading}</span>`;
      const links = col.links.map(l =>
        `<li><a href="${l.href}" class="b04-dropdown__link">${l.label}</a></li>`
      ).join('');
      return `
        <div class="b04-dropdown__col">
          ${headingEl}
          <ul class="b04-dropdown__links">${links}</ul>
        </div>
      `;
    }).join('');
    return `
      <div class="b04-dropdown">
        <div class="b04-dropdown__columns">${cols}</div>
        ${buildPromos(dropdown.promoKey)}
      </div>
    `;
  }

  function buildNav() {
    const items = NAV.map(item => {
      if (!item.dropdown) {
        return `
          <li class="b04-nav__item">
            <a href="${item.href}" class="b04-nav__trigger">${item.label}</a>
          </li>
        `;
      }
      return `
        <li class="b04-nav__item">
          <button class="b04-nav__trigger" aria-expanded="false" aria-haspopup="true">
            ${item.label} ${chevronSVG()}
          </button>
          ${buildDropdown(item.dropdown)}
        </li>
      `;
    }).join('');
    return `<ul class="b04-nav" role="list">${items}</ul>`;
  }

  // ─── MOBILE helpers ───────────────────────────────────────────────────────
  function closeSVG() {
    return `<svg viewBox="0 0 14.708 14.708" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M0,0H20V.8H0Z" transform="translate(0.566 0) rotate(45)" fill="currentColor"/>
      <path d="M0,0H20V.8H0Z" transform="translate(14.708 0.566) rotate(135)" fill="currentColor"/>
    </svg>`;
  }

  function chevronRightSVG() {
    return `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  }

  function chevronLeftSVG() {
    return `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  }

  function buildMobileDrawer() {
    const rootItems = MOBILE_NAV.map((item, i) => {
      if (!item.sub) {
        return `<li class="b04m-listItem"><a href="${item.href}" class="b04m-link">${item.label}</a></li>`;
      }
      return `<li class="b04m-listItem">
        <button class="b04m-expandable" data-panel="sub-${i}" aria-expanded="false">
          <span>${item.label}</span>
          <span class="b04m-chevron">${chevronRightSVG()}</span>
        </button>
      </li>`;
    }).join('');

    const promoTiles = MOBILE_PROMOS.map(p => `
      <a href="${p.href}" class="b04m-promo">
        <img src="${p.src}" alt="${p.label}" loading="lazy">
        <span class="b04m-promo-label">${p.label}</span>
      </a>
    `).join('');

    const subPanels = MOBILE_NAV.map((item, i) => {
      if (!item.sub) return '';
      const links = item.sub.map(l =>
        `<a href="${l.href}" class="b04m-sub-link">${l.label}</a>`
      ).join('');
      return `
        <div class="b04m-panel b04m-panel--sub" id="b04m-panel-sub-${i}" role="region" aria-label="${item.label}">
          <button class="b04m-back" data-back>
            ${chevronLeftSVG()}
            <span>${item.label}</span>
          </button>
          ${links}
        </div>
      `;
    }).join('');

    return `
      <div id="b04-mobile-drawer">
        <div class="b04m-header">
          <button class="b04m-close" aria-label="Close menu">${closeSVG()}</button>
        </div>
        <div class="b04m-panels">
          <div class="b04m-panel b04m-panel--root" id="b04m-panel-root">
            <div class="b04m-promos">${promoTiles}</div>
            <ul class="b04m-list" role="list">${rootItems}</ul>
          </div>
          ${subPanels}
        </div>
      </div>
    `;
  }

  // ─── Public API ───────────────────────────────────────────────────────────
  window.activateB04 = function () {
    if (window._b04Active) return;
    window._b04Active = true;

    // ── Desktop ──────────────────────────────────────────────────────────────
    if (!document.getElementById('b04-styles')) {
      const style = document.createElement('style');
      style.id = 'b04-styles';
      style.textContent = CSS;
      document.head.appendChild(style);
    }

    waitForElement('nav#main-navigation').then(existingNav => {

      const wrapper = document.createElement('nav');
      wrapper.id = 'b04-main-nav';
      wrapper.setAttribute('role', 'navigation');
      wrapper.innerHTML = buildNav();

      existingNav.style.display = 'none';
      existingNav.parentNode.insertBefore(wrapper, existingNav.nextSibling);

      const stickyEl = document.querySelector('sticky-header');

      function updateHeaderHeight() {
        if (!stickyEl) return;
        const bottom = Math.round(stickyEl.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--b04-header-height', bottom + 'px');
      }

      updateHeaderHeight();

      if (window.ResizeObserver) {
        new ResizeObserver(() => requestAnimationFrame(updateHeaderHeight))
          .observe(stickyEl || document.documentElement);
      }

      window.addEventListener('scroll', updateHeaderHeight, { passive: true });

      function closeAll() {
        wrapper.querySelectorAll('.b04-nav__item.is-open').forEach(el => {
          el.classList.remove('is-open');
          const btn = el.querySelector('.b04-nav__trigger[aria-expanded]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }

      wrapper.querySelectorAll('.b04-nav__item').forEach(item => {
        const trigger = item.querySelector('.b04-nav__trigger');
        const dropdown = item.querySelector('.b04-dropdown');
        if (!dropdown) return;
        trigger.addEventListener('click', e => {
          e.stopPropagation();
          const isOpen = item.classList.contains('is-open');
          closeAll();
          if (!isOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
      document.addEventListener('click', e => { if (!wrapper.contains(e.target)) closeAll(); });

    }).catch();

    // ── Mobile ───────────────────────────────────────────────────────────────
    if (!document.getElementById('b04-mobile-styles')) {
      const style = document.createElement('style');
      style.id = 'b04-mobile-styles';
      style.textContent = MOBILE_CSS;
      document.head.appendChild(style);
    }

    const menuDrawer = document.getElementById('menu-drawer');
    if (!menuDrawer) return;

    menuDrawer.innerHTML = buildMobileDrawer();

    const drawerEl  = document.getElementById('b04-mobile-drawer');
    const rootPanel = document.getElementById('b04m-panel-root');

    function closeDrawer() {
      const summary = document.querySelector('#Details-menu-drawer-container summary');
      if (summary) summary.click();
      document.body.style.overflowY = 'auto';
      document.body.style.height = 'auto';
      document.body.classList.remove('menu-open');
      const main = document.getElementById('MainContent');
      if (main) main.style.opacity = '1';
      const pixels = document.getElementById('WebPixelsManagerSandboxContainer');
      if (pixels) pixels.style.opacity = '1';
      const footer = document.getElementById('shopify-section-footer');
      if (footer) footer.style.opacity = '1';
      const chat = document.getElementById('chat-widget-container');
      if (chat) chat.classList.remove('hide');
      document.querySelector('.section-header')?.classList.remove('menu-opened');
    }

    drawerEl.querySelector('.b04m-close').addEventListener('click', e => {
      e.stopPropagation();
      closeDrawer();
    });

    drawerEl.querySelectorAll('.b04m-expandable').forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-panel');
        const subPanel = document.getElementById(`b04m-panel-${targetId}`);
        if (!subPanel) return;
        rootPanel.classList.add('is-behind');
        subPanel.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
      });
    });

    drawerEl.querySelectorAll('[data-back]').forEach(btn => {
      btn.addEventListener('click', () => {
        const subPanel = btn.closest('.b04m-panel--sub');
        if (!subPanel) return;
        subPanel.classList.remove('is-active');
        rootPanel.classList.remove('is-behind');
        const panelId = subPanel.id.replace('b04m-panel-', '');
        const expandable = drawerEl.querySelector(`[data-panel="${panelId}"]`);
        if (expandable) expandable.setAttribute('aria-expanded', 'false');
      });
    });

    const details = document.getElementById('Details-menu-drawer-container');
    if (details) {
      new MutationObserver(() => {
        if (!details.open) {
          setTimeout(() => {
            drawerEl.querySelectorAll('.b04m-panel--sub.is-active').forEach(p => p.classList.remove('is-active'));
            rootPanel.classList.remove('is-behind');
          }, 350);
        }
      }).observe(details, { attributes: true, attributeFilter: ['open'] });
    }

    console.log('[B04] Treatment active');
    window.sessionStorage.setItem("[B04] new nav", true);
  };

  if(window.sessionStorage.getItem("[B04] new nav")) {
    window.activateB04();
  }

})();

// End B04

//
// START [BOMB-05]
//

window.activate_bomb05v1 = () => {

  /*
  // cart-incentives -- v0.9.1
  */

  /*
  // DEFINITIONS
  // - threshold: often cart_total, sometimes unit count
  // - label: shows in the progress bar message + display,
  // - icon: when defined it this icon is in the bar display
  // - var_id: when defined this threshold displays an ATC module
  // - var_title: title in ATC module
  // - var_value: ATC subtext, e.g. "a $19 value)
  // - var_img: ATC image url
  // - _discount: sets the "_discount" cart attribute
  */

  const expid = "[BOMB-05]v1"; // default value of atc _discount prop "discount_prop
  // const injection_selector = "cart-items";
  const injection_selector = "ig-volume-progress-bar-widget";
  const injection_position = "afterbegin";
  const hide_injection_selector = true;
  const cart_count_type = "cart_total"; // or count qty of untis
  const unit_verbiage = ['pair', 'pairs']; // [0] singular, [1] plural
  const cart_count_source = window.cart_data.total_price; // window.cart_incentive_value (like count boxes or item)
  const accent_color = "#000";
  const success_message_prefix = "Congratulations! ";

  let incentives_data = [
    {
      threshold: 15000,
      label: "get <spang>free shipping</span>",
      cart_attributes: {
        _discount: "",
        _shipping: ""
      }
    },
  ]

  function in_mothers_day_time_window() {
    const now = new Date();

    // start/end in PDT explicitly (-7:00)
    const start = new Date("2026-05-09T06:00:00-07:00"); // May 9, 6:00 AM PDT
    const end   = new Date("2026-05-10T23:59:59-07:00"); // May 10, 11:59:59 PM PDT

    return now >= start && now <= end;
  }

  if (in_mothers_day_time_window() || window.location.href.indexOf("?free-shipping") > -1) {
    incentives_data = [
      {
        threshold: 100,
        label: "get <spang>free shipping</span>",
        cart_attributes: {
          _discount: "",
          _shipping: ""
        }
      },
    ]
  } else {
    // do nothing
  }

  if(window.sessionStorage.getItem(`${expid} active`)){

    incentives_data = [
      {
        threshold: 12500,
        label: "get <spang>free shipping</span>",
        cart_attributes: {
          _discount: "",
          _shipping: ""
        }
      },
    ]

    if(window.currency_iso_code == "USD"){
      proteus.add_cartAttribute("_shipping", "[BOMB-05]v1");
      observeSelector('.announcementMessage1', announcement => {
        if(announcement.innerText.indexOf("Free Shipping Over $150") > -1){
          announcement.innerHTML = "<span>Free Shipping Over $125</span>";
        }
      })

      if(window.location.href.indexOf("/pages/faqs-account") > -1){
        observeSelector('p', p => {
          if(p.innerText.indexOf("- USPS First Class Over $100 USD (3-4 business days) FREE") > -1){
            p.innerHTML = "- USPS First Class Over $125 USD (3-4 business days) FREE";
          }
        })
      }

      observeSelector('#product-message-usa i', announcement => {
        if(announcement.innerText.indexOf("Free standard shipping on orders over $150") > -1){
          announcement.innerHTML = "Free standard shipping on orders over $125";
        }
      })

      observeSelector('.content p', faq => {
        if(faq.innerText.indexOf("- USPS First Class Over $150 USD (3-4 business days) FREE") > -1){
          faq.innerHTML = "- USPS First Class Over $125 USD (3-4 business days) FREE";
        }
      })

      observeSelector('#shipping-rates-and-times .domestic-left li span', info => {
        if(info.innerText.indexOf("USPS First Class Under $150 (3-5 business days)") > -1){
          info.innerHTML = "USPS First Class Under $125 (3-5 business days) ";
        }
      })

      observeSelector('#shipping-rates-and-times .domestic-left li span', info => {
        if(info.innerText.indexOf("USPS First Class Over $150 (3-5 business days)") > -1){
          info.innerHTML = "USPS First Class Over $125 (3-5 business days) ";
        }
      })

    } else {
      proteus.add_cartAttribute("_shipping", "[BOMB-05]v1");
    }

  }

  // international settings
  if(window.currency_iso_code != "USD"){
    incentives_data = [
      /*{
        threshold: 20000,
        label: "get <spang>free shipping</span>",
      },
      */
    ]
  }

  /*
  // HELPER FUNCTIONS
  */

  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  // todo -- fold into utils
  const add_item_to_cart = (var_id, qty = 1, discount_prop = expid) => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: var_id,
            quantity: 1,
            properties: discount_props,
          },
        ],
      }),
    }).then(() => {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    });
  }

  const update_cart = (cart_total) => {

    let discount_prop = "";

    let incentives_bars = document.querySelectorAll('.js-progressive-incentive');
    for(let i = 0; i < incentives_bars.length; i++){
      let incentive = incentives_bars[i];

      let incentives_html = ``;
      let message_html = ``;
      for(let i = 0; i < incentives_data.length; i++){

        let threshold_met = cart_total >= incentives_data[i].threshold ? true : false;

        let threshold_gwp = typeof incentives_data[i].var_id == "number";
        let gwp_in_cart = cart_data.items.some(item => item.variant_id == incentives_data[i].var_id)

        let previous_threshold = i > 0 ? incentives_data[i - 1].threshold : 0;
        let threshold_progress = parseInt(((cart_total - previous_threshold) / (incentives_data[i].threshold - previous_threshold))*100);

        incentives_html += `
          <div class="js-progressive-incentive--threshold" data-threshold="${incentives_data[i].threshold}" data-met="${threshold_met}" data-progress="${Math.max(0, Math.min(100, threshold_progress))}">
            <div class="js-progressive-incentive--fill-container">
              <div class="js-progressive-incentive--fill" style="width: 0%;"></div>
            </div>

            <div class="js-progressive-incentive--label">
              <div class="js-progressive-incentive--icon" style="background: url(${incentives_data[i].icon}) center center no-repeat;"></div>

              ${incentives_data[i].label.replace("get a ", "").replace("get ", "")}
            </div>
          </div>
        `;

        if(message_html == ""){

          let met_message = ``;
          let already_met = ``

          if(i-1 >= 0){
            for(let ii = i-2; ii > -1; ii--){
              // progressively growing messaging
              // already_met += ` + ${incentives_data[ii].label.replace("get ", "")}`;
            }
            met_message = `You ${incentives_data[i-1].label}${already_met}!<br>`;
            discount_prop = incentives_data[i-1]._discount;
          }

          let needed = incentives_data[i].threshold - cart_total;

          if(cart_count_type == "cart_total"){
            needed = parseFloat((incentives_data[i].threshold - cart_total)/100).toFixed(2);
          }

          let count_text = `${window.currency_symbol || "$"}${needed}`; // fallback to $
          let unit_text = "more";
          if(cart_count_type != "cart_total"){

            unit_text = needed === 1 ? unit_verbiage[0] :unit_verbiage[1];
            count_text = needed === 1 ? 'one more' : `${needed} more`;
            if(needed === 2){
              count_text = "two more"
            } else if(needed === 3){
              count_text = "three more"
            } else if(needed === 4){
              count_text = "four more"
            } else if(needed === 5){
              count_text = "five more"
            }
          }

          if (!threshold_met) {
            message_html = `${met_message} Add ${count_text} ${unit_text} to ${incentives_data[i].label}`;
            if(i == 0){
              message_html = `${met_message} Add ${count_text} ${unit_text} to ${incentives_data[i].label}`;
            }
          } else if (threshold_met && i === incentives_data.length - 1) {

            already_met = ``
            for(let ii = incentives_data.length - 2; ii >= 0; ii--){
              // progressively growing messaging
              // already_met += ` + ${incentives_data[ii].label.replace("get ", "")}`;
            }

            message_html = `${success_message_prefix}You ${incentives_data[i].label}${already_met}!`;
            discount_prop = incentives_data[i]._discount;
          }

          console.log("checking", threshold_gwp, gwp_in_cart, threshold_met);

          if(threshold_met && threshold_gwp && !gwp_in_cart &&
          document.querySelectorAll(`.js-offer--container[data-var-id="${incentives_data[i].var_id}"]`).length == 0){

            // add GWP
            document.querySelector('.js-progressive-incentive').insertAdjacentHTML('afterend', `
              <div class="js-offer--container" data-var-id="${incentives_data[i].var_id}">
                <style>
                .js-offer--container{
                  margin-bottom: -3.5rem;
                }
                [data-var-id="${incentives_data[i].var_id}"] .js-offer{
                    background: #f5f5f5 url(${incentives_data[i].var_img}) no-repeat;
                    background-size: 85px;
                    background-position: 1em center;
                    margin: 1rem 0;
                    padding: 1rem 2rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #222;
                }

                .js-offer > div:first-child{
                    padding-left: 85px;
                }
                .js-offer > div span{
                    font-size: .75rem;
                }
                .js-offer > div:last-child span{
                    margin-top: -.5rem;
                }
                .js-offer .js-gwp-atc{
                    transform: scale(.75);
                    transform-origin: left;
                    border-radius: 25px;
                    padding: .5rem 1.5rem;
                    margin-bottom: 5px;
                    display: inline-block;
                    background: ${accent_color};
                    cursor: pointer;
                    color: #fff;
                }
                @media(max-width: 525px){
                    .js-offer{
                        display: block;
                    }
                    .js-offer .js-gwp-atc{
                        margin-left: 0;
                    }
                }

                </style>
                <div class="js-offer">

                    <div>
                        <div>
                          Claim your <strong>${incentives_data[i].var_title}</strong>
                        </div>
                        <div class="js-gwp-atc" data-var-id="${incentives_data[i].var_id}">Add to Cart</div>
                        <span style="display: block;">a ${incentives_data[i].var_value} value</span>
                    </div>

                </div>
              </div>
            `);

            waitForElement('.js-gwp-atc').then(gwp_atc => {

              let var_id = gwp_atc.getAttribute("data-var-id");
              gwp_atc.addEventListener("click", () => {
                add_item_to_cart(var_id, 1, expid);
              });

            }).catch();

          }

        }
      }

      incentive.querySelector('.js-progressive-incentive--message').innerHTML = message_html;
      incentive.querySelector('.js-progressive-incentive--message').setAttribute("data-cart-total", cart_total);

      incentive.querySelector('.js-progressive-incentive--bar').innerHTML = incentives_html;
      incentive.querySelector('.js-progressive-incentive--bar').setAttribute("data-cart-total", cart_total);

      // could be delayed to give an animation
      setTimeout(() => {
        let thresholds = document.querySelectorAll('.js-progressive-incentive--threshold');
        for(let i = 0; i < thresholds.length; i++){
          let threshold_progress = thresholds[i].getAttribute("data-progress");
          thresholds[i].querySelector('.js-progressive-incentive--fill').style.width = `${threshold_progress}%`;
        }
      }, 10)

    } // for each incentives bar

    const current = cart_data?.attributes?._discount || "";
    const next = discount_prop || "";

    // do nothing if same
    if (current === next) return;

    // build payload
    let value_to_set = next;

    // if empty → unset
    if (!next) {
      value_to_set = "";
    }

    proteus.add_cartAttribute("_discount", value_to_set).then(() => {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    });

  } // update_cart(cart_total)

  // init
  update_cart(window.cart_data.total_price);

  observeSelector(injection_selector, fs_bar => {

    // let fs_bar = fs_bar_content.parentNode;
    if(hide_injection_selector){
      fs_bar.style.display = "none";
    }

    if(fs_bar.parentNode.querySelectorAll('.js-progressive-incentive').length == 0 && incentives_data.length > 0){
      // document.querySelector('.cart-drawer__line-items').insertAdjacentHTML("beforebegin", `
      fs_bar.insertAdjacentHTML("afterend", `
        <div class="js-progressive-incentive">
          <div class="js-progressive-incentive--bar"></div>
          <div class="js-progressive-incentive--message"></div>
        </div>
      `);
    }

    // init
    update_cart(window.cart_data.total_price);

  });

  /*
  LISTEN FOR CHANGES
  */
  let cart_count = 0;
  setInterval(() => {
    if(cart_count != window.cart_data.total_price){
      cart_count = window.cart_data.total_price;
      //console.log("cart count", cart_count);
      update_cart(window.cart_data.total_price);
    }
  }, 200)

  /*
  INJECT GLOBAL STYLES
  */
  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
      <style>

      .js-progressive-incentive{
        padding: 0 1rem 1.5rem 1rem;
        border-color: #666;
        font-size: 1rem;
      }

      @media(max-width: 768px){
        .js-progressive-incentive{
          font-size: .85rem;
          padding: 0 0 1.5rem 0;
        }
      }

      .js-progressive-incentive--message[data-cart-total="0"],
      .js-progressive-incentive--bar[data-cart-total="0"]{
        display: none;
      }

      .js-progressive-incentive--message{
        text-align: center;
        padding: .25rem 0;
        font-weight: 600;
        font-size: 14px;
      }
      .js-progressive-incentive--message span{

      }
      .js-progressive-incentive--bar{
        display: flex;
        border-left: 1px solid transparent;
        overflow: hidden;
        background: #bdbdbd80;
        border-radius: 10px;
        margin: 1rem 0;
      }

      .js-progressive-incentive--threshold{
        padding: .25rem;
        position: relative;
        border-left: 1px solid;
        width: 100%;
      }

      .js-progressive-incentive--threshold:first-child{
        border-left: 0;
      }

      .js-progressive-incentive--threshold:first-child .js-progressive-incentive--fill-container,
      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--fill-container{
        border-radius: 10px 0 0 10px;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--fill-container{
        border-radius: 0 10px 10px 0;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .js-progressive-incentive--fill{
        background: ${accent_color};
        position: absolute;
        border-radius: 10px;
        top: 0;
        left: 0;
        height: 100%;
        max-width: 100%;
        min-width: 0;
        width: 0;
      }

      .js-progressive-incentive--label:after{
        /* content: ""; */
        position: absolute;
        top: 0;
        left: 0;
        padding: 5px;
        background: #000;
      }

      .js-progressive-incentive--label{
        font-size: .85rem;
        position: absolute;
        right: -50%;
        bottom: -1.5rem;
        width: 100%;
        text-align: center;
        /*
        for this one onlye
        */
        display: none;
      }

      .js-progressive-incentive--icon{
        display: none;
        position: absolute;
        z-index: 5;
        top: -2.15rem;
        right: 50%;
        transform: translateX(50%);
        width: 1.5rem;
        height: 1.5rem;
        background-size: 80% !important;
        vertical-align: bottom;
        background-color: #fff !important;
        border: 1px solid #000;
        border-radius: 100px;
      }

      [data-met="true"] .js-progressive-incentive--icon{
        background-color: ${accent_color} !important;
      }

      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--icon{
        right: 0;
        transform: none;
      }

      @media(max-width: 768px){
        .js-progressive-incentive--label{
          font-size: .75rem;
          height: 2em;
        }
      }

      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--label{
        right: -.5rem;
        text-align: right;
      }

      .js-progressive-incentive--threshold:not([data-progress="100"],
      [data-progress="0"]) .js-progressive-incentive--fill{
        /* transition: 1.5s ease; */
      }

      [data-progress="100"] .js-progressive-incentive--fill{
        width: 100% !important;
      }
      </style>
    `);
  }).catch();


}; // window.activate_bomb05v1()

// init
window.activate_bomb05v1();

//
// END [BOMB-05]
//